/** v5 Feed item renderer — chat messages + inline plans + clarification + approval + checkpoint.
 *  All interactive cards render inline in the chat feed (not in right panels).
 *  Per-type UI lives under ./feedItem/. */
import type { FeedItem as FeedItemT } from "@/stores/devAgentStore";
import { FEED_ITEM_RENDERERS } from "./feedItem/feedItemRenderers";
import { InlineErrorBoundary } from "./feedItem/InlineErrorBoundary";
import type { FeedItemComponentProps } from "./feedItem/types";

export type FeedItemProps = FeedItemComponentProps;

export function FeedItem({
  item,
  onFeedback,
  onSendMessage,
  disabled,
}: FeedItemProps) {
  const Renderer = FEED_ITEM_RENDERERS[item.type];
  return Renderer ? (
    <InlineErrorBoundary>
      <Renderer
        item={item}
        onFeedback={onFeedback}
        onSendMessage={onSendMessage}
        disabled={disabled}
      />
    </InlineErrorBoundary>
  ) : null;
}
